<template>
    <div :class="[
        'popup-overlay',
        { 'on': on }
    ]"
        @click="$emit('closePopup')"
    >

    </div>
</template>

<script>
export default {
    name: "Overlay",
    props: {
        on: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/mixins-and-vars';

$parent: '.popup-overlay';

#{$parent} {
    position: absolute;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.8);
    cursor: pointer;
    animation: easeOpen .45s ease-in-out;
}

@keyframes easeOpen {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

</style>